/* global angular */
( function () {
	'use strict';

	function GroupPager ( $window, scope, collectionService, focusModel ) {
		var self   = this;
		var length = 0;

		function safeCollection () {
			return self.collection || [];
		}

		function liveLength () {
			return safeCollection().length;
		}

		function setLength () {
			length = liveLength();
		}

		function safeModelAtIndex ( index ) {
			return safeCollection()[ index ] || {};
		}

		function updateModelWithLength ( condition, index ) {
			if ( condition ) {
				focusModel.set( safeModelAtIndex( index ) );
				setLength();
			}
		}

		function safeModel ( initialModel ) {
			focusModel.set( initialModel || focusModel.get() || safeModelAtIndex( 0 ) );
			updateModelWithLength( length > liveLength(), 0 );
			updateModelWithLength( length < liveLength(), liveLength() - 1 );
			return focusModel.get();
		}

		function getCurrentIndex () {
			return collectionService.getIndex( safeCollection(), safeModel() );
		}

		function isNotLast () {
			return liveLength() > getCurrentIndex() + 1;
		}

		function showGroupName ( direction ) {
			var group = safeCollection()[ getCurrentIndex() + direction ];

			return group.groupName || group.name || '';
		}

		function showRightGroupName () {
			return showGroupName( 1 );
		}

		function isNotFirst () {
			return getCurrentIndex() - 1 >= 0;
		}

		function showLeftGroupName () {
			return showGroupName( -1 );
		}

		function getValidity () {
			return focusModel.getValidityForm( self.isValidFrm );
		}

		function view ( direction ) {
			if ( getValidity() ) {
				$window.scrollTo( 0, 0 );

				focusModel.set( safeCollection()[ getCurrentIndex() + direction ] );
			}
		}

		function activate () {
			focusModel.reset();
			focusModel.setValid( self.isValidFrm );
			scope.$parent.activeGroup = safeModel;
			setLength();
		}

		self.left  = -1;
		self.right = 1;
		self.view  = view;

		self.isNotFirst = isNotFirst;
		self.isNotLast  = isNotLast;
		self.setLength  = setLength;
		self.isValid    = getValidity;

		self.currentModel       = safeModel;
		self.showLeftGroupName  = showLeftGroupName;
		self.showRightGroupName = showRightGroupName;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'GroupPager', GroupPager );

	GroupPager.$inject = [ '$window', '$scope', 'collectionService', 'groupPagerFactory' ];
} )( );
